import React, { useState } from 'react';

// --- Main Component ---
export function LocalisedAlert({ 
  message, 
  variant = 'warning', 
}) {
  const languages = Object.keys(message);
  const [currentLanguage, setCurrentLanguage] = useState(
    languages.find(lang => lang !== "English") || languages[0]
  );

  const style = {
    error: { bg: '#FEF2F2', border: '#FCA5A5', accent: '#EF4444', text: '#991B1B', label: 'Error' },
    warning: { bg: '#FFFBEB', border: '#FCD34D', accent: '#F59E0B', text: '#92400E', label: 'Note' }
  }[variant] || { bg: '#F9FAFB', border: '#D1D5DB', accent: '#6B7280', text: '#374151', label: 'Info' };

  return (
    <div style={{
      backgroundColor: style.bg,
      border: `1px solid ${style.border}`,
      borderLeft: `4px solid ${style.accent}`,
      borderRadius: '8px',
      overflow: 'hidden',
      margin: '0',
      fontFamily: 'sans-serif'
    }}>
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '6px 12px',
        borderBottom: `1px solid ${style.border}55`
      }}>
        <span style={{ fontSize: '0.65rem', fontWeight: '800', color: style.accent, letterSpacing: '0.05rem' }}>
          {style.label.toUpperCase()}
        </span>

        <div style={{ display: 'flex', background: 'rgba(0,0,0,0.06)', borderRadius: '20px', padding: '2px' }}>
          {languages.map((lang) => (
            <button
              key={lang}
              onClick={() => setCurrentLanguage(lang)}
              style={{
                border: 'none',
                background: currentLanguage === lang ? '#fff' : 'transparent',
                color: currentLanguage === lang ? '#000' : '#666',
                padding: '2px 10px',
                borderRadius: '15px',
                fontSize: '0.65rem',
                cursor: 'pointer',
                fontWeight: currentLanguage === lang ? '600' : '400',
                boxShadow: currentLanguage === lang ? '0 1px 2px rgba(0,0,0,0.1)' : 'none'
              }}
            >
              {lang}
            </button>
          ))}
        </div>
      </div>

      <div style={{ padding: '12px', color: style.text, fontSize: '0.85rem', lineHeight: '1.5' }}>
        <p style={{ margin: 0, textAlign:'left' }}>
          {message[currentLanguage]}
        </p>
      </div>
    </div>
  );
}
